import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgLeftLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M17.5 1L6.5 12.11L17.5 23"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgLeftLarge.displayName = 'SvgLeftLarge';
const LeftLarge = withForgeIconProps(SvgLeftLarge, {
  name: 'Left',
  usage: 'Use to go back to the previous page or item.',
  related: 'return, navigation',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default LeftLarge;
